import React, {Component} from 'react';
import {observable, action} from 'mobx';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';

import './alaCarte.scss';
import CheckedList from '../common/FeatureList';
import CreditCounter from '../common/CreditCounter';

const MAX_CREDIT_COUNT = 99;

/**
 * The AlaCarteItem component.
 */
class AlaCarteItem extends Component {
  /**
   * How many credits the user would like to purchase
   *
   * @type {number}
   */
  @observable creditCount = 0;

  /**
   * Triggered when the component first mounts to the page.
   */
  @action componentDidMount() {
    const {quantity} = this.props;

    if (quantity) {
      this.creditCount = quantity;
    }
  }

  /**
   * Updates the Credit Count
   *
   * @param {number} newCreditCount
   */
  @action onCreditChange(newCreditCount) {
    const {id, updateCredit} = this.props;
    const validCreditCount = newCreditCount <= MAX_CREDIT_COUNT && newCreditCount >= 0;
    if (validCreditCount) {
      updateCredit(id, parseInt(newCreditCount, 10));
    }
  }

  /**
   * Renders the AlaCarteItem Component
   * @returns {{}}
   */
  render() {
    const {header, quantity, title, description, pricePerCredit, features, style} = this.props;

    return (
      <>
        <div className={`alacarte-item ${style.background}`}>
          <div className="text-center">
            <div className={`item-header ${style.header}`}>{header}</div>
            <CreditCounter
              pricePerCredit={pricePerCredit}
              quantity={quantity}
              updateCredit={(newCredit) => this.onCreditChange(newCredit)}
            />
          </div>
          <div className="item-description">
            <div className="item-description-title">
              {title}
            </div>
            <div className="item-description-content">
              {description}
            </div>
          </div>
          <div className="item-features">
            <CheckedList features={features} />
          </div>
        </div>
      </>
    );
  }
}

AlaCarteItem.propTypes = {
  description: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  pricePerCredit: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  updateCredit: PropTypes.func.isRequired,

  features: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
};

AlaCarteItem.defaultProps = {
  features: [],
  style: {
    header: 'primary',
    background: 'white'
  },
};

export default observer(AlaCarteItem);
